import React from 'react';
import UserCard from './UserCard';
import { User, LeaderboardType } from '../types';
import { Loader2 } from 'lucide-react';

interface LeaderboardProps {
  title: string;
  type: LeaderboardType;
  users: User[];
  loading: boolean;
  error: string | null;
}

const Leaderboard: React.FC<LeaderboardProps> = ({ 
  title, 
  type, 
  users, 
  loading, 
  error 
}) => {
  return (
    <div className="animate-fadeIn">
      <h2 className="text-xl font-bold text-white mb-6">{title}</h2>
      
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <Loader2 className="w-8 h-8 text-amber-500 animate-spin" />
        </div>
      ) : error ? (
        <div className="text-red-500 p-4 bg-red-100 rounded-lg">
          {error}
        </div>
      ) : users.length === 0 ? (
        <div className="text-center py-8 text-slate-400">
          No users found for this leaderboard.
        </div>
      ) : (
        <div className="space-y-1">
          {users.map((user, index) => (
            <UserCard
              key={user.id}
              user={user}
              rank={index + 1}
              type={type}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Leaderboard;